module.exports = __webpack_public_path__ + "img/David Jesin, Co-Director of Events, Schulich Finance Association.06209820.webp";